/**
 * assets/content-visibility.js
 * content-visibility: auto voor de homepage-secties onder de hero en de footer-groep. Alleen op de
 * homepage geladen, met defer. Zie ARCHITECTURE.md sectie 6 "content-visibility".
 *
 * Waarom: een modal (showModal, mobiel menu, zoeken) maakt de rest van de pagina inert en Chrome
 * herberekent dan het hele document. Secties ver buiten beeld overslaan halveert dat. Gemeten (mobiel,
 * 4x CPU): menu openen 292-404 naar 134-166 ms, sluiten 281-399 naar 87-156 ms.
 *
 * Hoe, en waarom zo:
 * - Na de eerste frame meet dit script elke sectie en zet content-visibility alleen op secties die
 *   op dat moment VER buiten beeld staan (meer dan 1,5 schermhoogte). Een sectie in of vlak bij beeld
 *   eerst overslaan en een frame later tonen telt Chrome als layout shift (gemeten: CLS 0,055 op de
 *   homepage-sectie die net in beeld valt). Zo'n sectie houdt dus gewoon alles.
 * - contain-intrinsic-size krijgt de gemeten hoogte ('auto' = daarna de echte, onthouden hoogte), zodat
 *   de pagina even lang blijft. Met een vaste schatting werd de pagina 13.867 in plaats van 18.168 px.
 * - Terug/vooruit en herladen ('back_forward', 'reload'): de browser herstelt dan de scrollpositie
 *   tijdens het laden; zonder bfcache kom je met content-visibility op een andere plek uit. Dan niets.
 * - Voorwaarden per sectie (gecontroleerd 14-10-2026): geen position fixed/sticky, geen <dialog>, niets
 *   dat buiten de sectie uitsteekt (content-visibility knipt overloop af). Nieuwe sectie onder de hero
 *   met een dropdown, sticky balk of modal? Dan uitsluiten in SECTIES.
 */
(function () {
  'use strict';
  var SECTIES = '#MainContent > [id$="__hero"] ~ .shopify-section, .shopify-section-group-footer-group';

  function aan() {
    try {
      var lijst = document.querySelectorAll(SECTIES);
      var vh = window.innerHeight, marge = vh * 1.5, maten = [];
      for (var i = 0; i < lijst.length; i++) maten.push(lijst[i].getBoundingClientRect());
      for (var j = 0; j < lijst.length; j++) {
        var r = maten[j];
        if (r.bottom > -marge && r.top < vh + marge) continue;
        lijst[j].style.containIntrinsicSize = 'auto ' + r.height + 'px';
        lijst[j].style.contentVisibility = 'auto';
      }
    } catch (e) { /* zonder content-visibility rendert alles gewoon */ }
  }

  try {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type !== 'navigate') return;
  } catch (e) { return; }

  function start() { requestAnimationFrame(function () { setTimeout(aan, 0); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
